<script lang="ts">
    import { REWARDS_DISCOUNT_TYPES } from "@apps/rewards/constants/rewardsDiscountTypes";
    import type { DiscountRewardEntity } from "@apps/rewards/entities/entities";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    import T from "@components/T.svelte";

    import RewardsCurrency from "../RewardsCurrency.svelte";

    //Props
    export let reward: DiscountRewardEntity;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let namespace: TranslationNamespaces;
    export let sanitizer: HTMLSanitizerInterface;

    const discount = Math.abs(reward.discountValue || 0);
</script>

{#if reward.discountType === REWARDS_DISCOUNT_TYPES.fixedAmount}
    <RewardsCurrency
        let:amount
        amount={discount}
        {currencyFormatter}
        {sanitizer}
    >
        <T
            {namespace}
            translationKey="fixed_discount_reward"
            translationOptions={{
                discount: amount,
            }}
        />
    </RewardsCurrency>
{:else if reward.discountType === REWARDS_DISCOUNT_TYPES.percentage}
    <T
        {namespace}
        translationKey="percentage_discount_reward"
        translationOptions={{
            discount,
        }}
    />
{:else}
    <T {namespace} translationKey="free_shipping_reward" />
{/if}
